



































































import {Component, Prop, Vue} from "vue-property-decorator";
import {UnitSystem} from "@/interfaces/units";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {
  IPrSimulatedLayerImperial,
  IPrTireLoadImperial,
  IPrTireLoadMetric,
  IWesleaConfig,
  IWesleaResult
} from "@/modules/perRoad/interfaces/monteCarlo";

import {all, create} from "mathjs";
import {formatStrainResult} from "@/lib/util/numberFormatters";
import {getLayerResultItems} from "@/modules/structure/lib/evaluateResults";
import {
  IPavementStructureScenarioImperial,
  IPavementStructureScenarioMetric
} from "@/modules/structure/interfaces/pavementStructure";

const mathjsConfig = {};
const math = create(all, mathjsConfig);


Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationLayoutInspector,
  },
})
export default class LayerResults extends Vue {

  @Prop() id!: string;

  @Prop() simulatedLayer!: IPrSimulatedLayerImperial;
  @Prop() scenario!: IPavementStructureScenarioImperial | IPavementStructureScenarioMetric;

  @Prop() loads!: IPrTireLoadMetric | IPrTireLoadImperial;

  @Prop() wesleaConfig!: IWesleaConfig;

  @Prop() wesleaResults!: IWesleaResult[];

  @Prop({default: 0}) layerNumber!: number;

  @Prop({default: 0}) externalPlotKey!: number;


  get layerDepthToShow() {
    // const topDepth = this.simulatedLayer.depthOfLayerTop_in;
    // const bottomDepth = this.simulatedLayer.depthOfLayerBottom_in;
    return this.selectedResultDepth;
  }

  get isImperial() {
    return this.simulatedLayer.unitSystem === UnitSystem.Imperial;
  }

  sync() {
    this.incrementPlotKey();

  }

  internalPlotKey = 0;

  get plotKey() {
    return this.internalPlotKey + this.externalPlotKey;
  }

  incrementPlotKey() {
    this.internalPlotKey += 1;
  }

  get layerTopWesleaConfig(): IWesleaConfig {
    return this.filterWesleaConfig(this.layerNumber, this.simulatedLayer.depthOfLayerTop_in);
  }

  get layerBottomWesleaConfig(): IWesleaConfig {
    return this.filterWesleaConfig(this.layerNumber, this.simulatedLayer.depthOfLayerBottom_in);
  }

  filterWesleaConfig(layerNumber: number | null = null, depth_in: number | null = null) {

    const filteredConfig = {...this.wesleaConfig};

    filteredConfig.criticallocations = this.wesleaConfig.criticallocations.filter(cr => {
      let isCorrectLayer = true;
      let isCorrectDepth = true;
      if (layerNumber !== null) {
        isCorrectLayer = cr.l === layerNumber;
      } else {
        isCorrectLayer = cr.l === this.layerNumber;
      }
      if (depth_in !== null) {
        isCorrectDepth = cr.z === depth_in;
      }
      return isCorrectLayer && isCorrectDepth;
    });

    return filteredConfig;
  }

  filterWesleaResults(layerNumber: number | null = null, depth_in: number | null = null) {

    return this.wesleaResults.filter((r, i) => {

      // console.log(i, r.id, r.location,r.normal_strain.x, r.normal_strain.y, r.normal_strain.z);

      let isCorrectLayer = true;
      let isCorrectDepth = true;

      if (layerNumber !== null) {
        isCorrectLayer = r.layer === layerNumber;
      } else {
        isCorrectLayer = r.layer === this.layerNumber;
      }

      if (depth_in !== null) {
        try {
          isCorrectDepth = r.location.z === depth_in;
        } catch (e) {
          // console.error(e);
          // console.debug(r);
        }
      }

      return isCorrectLayer && isCorrectDepth;
    });
  }

  get resultOptions() {
    return ["deflection", "normal_strain", "normal_stress", "shear_stress", "location"];
  }

  get depthOptions() {
    return [
      {
        text: `Top of layer (${this.simulatedLayer.depthOfLayerTop_in} in)`,
        value: this.simulatedLayer.depthOfLayerTop_in
      },
      {
        text: `Bottom of layer (${this.simulatedLayer.depthOfLayerBottom_in} in)`,
        value: this.simulatedLayer.depthOfLayerBottom_in
      }
    ];
  }

  selectedResultType = "normal_strain";

  selectedResultDepth = this.simulatedLayer.depthOfLayerBottom_in;

  formatStrainResult = formatStrainResult;

  get resultFields() {
    return [
      {key: "x", sortable: true},
      {key: "y", sortable: true},
      {key: "z", sortable: true},
      {key: "horizStrain", sortable: true},
      {key: "verticalStrain", sortable: true},
    ];
  }

  get resultItems() {
    return getLayerResultItems(this.filterWesleaResults(this.simulatedLayer.layerNumber, this.layerDepthToShow), this.simulatedLayer, this.scenario);
  }

}

